import type { AxiosResponse } from 'axios';

import { baseUrl, formRoutes } from '@/api/config';
import axiosInstance from '@/api/instance';

import ROUTES from '../../routes';
import type { IImage } from './types';

export const create = (data: File)
  : Promise<void | AxiosResponse<IImage>> => axiosInstance({
  baseURL: `${baseUrl}${formRoutes}`,
  url: `${ROUTES.IMAGES}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});
